import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import type { CurrentUser } from "@/react/types/CurrentUser";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { Form } from "@circle-react-uikit/Form";

export const CommunityNameInput = () => {
  const { setValue } = useFormContext();
  const localeScope = "authentication_app.create_community";
  const { currentUser } = useCurrentCommunityContext();

  const generateCommunityName = (user: Pick<CurrentUser, "first_name">) => {
    const firstName = user.first_name;
    const focusWord = t(`${localeScope}.autogenerated_name.community`);

    return `${firstName}'s ${focusWord}`;
  };

  useEffect(() => {
    if (currentUser) {
      setValue("community[name]", generateCommunityName(currentUser));
    }
  }, [currentUser]);

  return (
    <Form.Item
      isFirstChild
      name="community[name]"
      label={t(`${localeScope}.form.name`)}
      hideDescription
      hideBorder
      rules={{
        required: t(`${localeScope}.form.errors.name_required`),
      }}
    >
      <Form.Input autoFocus data-testid="community_name" />
    </Form.Item>
  );
};
